<template>
  <component
    :is="element"
    :style="{
      width,
      '-webkit-line-clamp': lineClamp,
      'white-space': lineClamp === 1 ? 'nowrap' : 'normal',
      display: lineClamp > 1 ? '-webkit-box' : 'block'
    }"
    class="text-ellipsis"
  >
    <slot />
  </component>
</template>

<script>
export default {
  props: {
    element: {
      type: String,
      default: 'span'
    },
    width: {
      type: String,
      default: 'auto'
    },
    lineClamp: {
      type: Number,
      default: 1
    }
  }
}
</script>

<style scoped>
  .text-ellipsis {
    overflow: hidden;
    text-overflow: ellipsis;
    -webkit-box-orient: vertical;
  }
</style>
